import type { POSOpenDocumentEventData } from '@nsftx/seven-client-retail-vue-integrator'
import { useDocumentViewerStore } from '#src/stores/documentViewerStore'

export const handleDocumentOpen = (data: POSOpenDocumentEventData) => {
  const { openDocumentViewerModal } = useDocumentViewerStore()

  openDocumentViewerModal({
    title: data.title,
    src: data.url,
    contentType: data.contentType,
  })
}
